<template>
  <div class="page_container companyListPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/mine' }">我的</el-breadcrumb-item>
        <el-breadcrumb-item>加入企业or团队</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <!-- <p class="flex-rowl" @click="handleGo()">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p> -->
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="请输入企业名称→"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.logo" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      <span>{{ item.qyname }}</span>
                    </p>
                    <p>
                      <span>{{ item.qyename }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p class="label_item" v-if="item.label1_name">
                      <span>{{ item.label1_name }}</span>
                    </p>
                    <p class="label_item" v-if="item.label2_name">
                      <span>{{ item.label2_name }}</span>
                    </p>
                    <p class="label_item" v-if="item.label3_name">
                      <span>{{ item.label3_name }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      所在地区：<span>{{ item.provincename }} {{ item.cityname }}
                      {{ item.areaname }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="editBtn" @click="handleGo(item.id)">
                详情→
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无企业or团队"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>
<script>
import { getCompanyList } from "../../api/company";
import storage from "../../utils/storage";
export default {
  name: "companyList",
  props: {
    keyword: String,
  },
  data() {
    return {
      params: {
        Page: 1,
        PageSize: 10,
        keyword: "",
        openid: storage.get("OPENID"),
      },
      listTotal: 0,
      dataList: [],
      loading: false,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let { params } = this;
      this.loading = true; //防止第一页重复加载
      getCompanyList(params).then((res) => {
        this.listTotal = res.total;
        this.dataList = res.list;
        this.loading = false;
      });
    },
    handleCurrentChange(e) {
      this.params.Page = e;
      this.initData();
    },

    handleSearch() {
      this.initData()
    },
    handleGo(id) {
      this.$router.push(`/companyIndex/companyDetail/${id}`);
    },
  },
};
</script>
<style lang="less" scoped>
.companyListPage {
  .item_main_wrap {
    .pic_box {
      width: 100px;
      height: 100px;
    }
  }
}
</style>